// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import VueAxios from './plugins/axios'
import VueDatoImage from '@voorhoede/vue-dato-image'
import Loading from 'vue-loading-overlay'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import VueScrollTo from 'vue-scrollto'
import ProgressBar from 'vuejs-progress-bar'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'typeface-roboto/index.css'
import store from './store'

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueAxios)
Vue.use(VueDatoImage)
Vue.use(Loading)
Vue.use(VueScrollTo)
Vue.use(ProgressBar)
Vue.component('v-select', vSelect)
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js